import templatesApi from '@/utils/api/templates';
import templatesApiV2 from '@/utils/api-v2/templates';
import { CONVERT_FROM_UTC, PARSE_DATE, PARSE_TIME } from '@/helpers/dates';
import { getField, updateField } from 'vuex-map-fields';

const setTemplatesData = (data) => {
    return data.map(el => ({
        id: el.id,
        identification_number: el.identification_number,
        color: el.color,
        archive: el.archive,
        date_inserted: el.date_inserted
            ? `${PARSE_DATE(CONVERT_FROM_UTC(el.date_inserted))} ${PARSE_TIME(CONVERT_FROM_UTC(el.date_inserted))}`
            : el.date_inserted,
        name: el.name,
        number_of_random_questions: el.number_of_random_questions,
        is_osm_template: el.is_osm_template
    }));
};

const defaultGroupAssignmentData = () => ({
    action: null,
    employeesGroupsIds: [],
    employeesIds: [],
    customersIds: [],
    sitesIds: [],
    locationsIds: [],
    templatesIds: []
});

export default {
    namespaced: true,
    state: () => ({
        rawTemplates: [],
        secondRawTemplates: [],
        rawTemplateQuestions: [],
        totalTemplatesAmount: null,
        secondtotalTemplatesAmount: null,
        templateQuestionTypes: [],
        groupAssignmentData: defaultGroupAssignmentData()
    }),
    getters: {
        getField,
        filterableTemplates: state => state.rawTemplates.map(el => ({
            value: el.id,
            text: el.name
        })),
        secondFilterableTemplates: state => state.secondRawTemplates.map(el => ({
            value: el.id,
            text: el.name
        })),
        filterableTemplateQuestions: state => state.rawTemplateQuestions.map(el => ({
            value: el.id,
            text: el.question
        }))
    },
    mutations: {
        updateField,
        SET_RAW_TEMPLATES (state, payload) {
            state.rawTemplates = payload;
        },
        SET_SECOND_RAW_TEMPLATES (state, payload) {
            state.secondRawTemplates = payload;
        },
        SET_RAW_TEMPLATE_QUESTIONS (state, payload) {
            state.rawTemplateQuestions = payload;
        },
        SET_TOTAL_TEMPLATES_AMOUNT (state, payload) {
            state.totalTemplatesAmount = payload;
        },
        SET_TEMPLATE_QUESTION_TYPES (state, payload) {
            state.templateQuestionTypes = payload;
        },
        RESET_GROUP_ASSIGNMENT_DATA (state) {
            state.groupAssignmentData = defaultGroupAssignmentData();
        }
    },
    actions: {
        getTemplates ({ commit }, additionalParams = null) {
            const secondTemplate = additionalParams && additionalParams.secondTemplate;
            if (secondTemplate) {
                commit('SET_SECOND_RAW_TEMPLATES', []);
            } else {
                commit('SET_RAW_TEMPLATES', []);
            }
            const params = {
                ordering: 'name'
            };

            if (additionalParams) {
                Object.keys(additionalParams).forEach(k => {
                    params[k] = additionalParams[k];
                });
            }

            return templatesApiV2.getTemplates(params)
                .then(({ data }) => {
                    if (additionalParams && additionalParams.secondTemplate) {
                        commit('SET_SECOND_RAW_TEMPLATES', setTemplatesData(data.results));
                    } else {
                        commit('SET_RAW_TEMPLATES', setTemplatesData(data.results));
                    }

                    commit('SET_TOTAL_TEMPLATES_AMOUNT', data.count);
                });
        },
        getTemplatesLazyLoading ({ commit, state }, additionalParams = null) {
            const secondTemplate = additionalParams && additionalParams.secondTemplate;
            const params = {
                ordering: 'name'
            };

            if (additionalParams) {
                Object.keys(additionalParams).forEach(k => {
                    params[k] = additionalParams[k];
                });
            }

            return templatesApiV2.getTemplates(params)
                .then(({ data }) => {
                    if (secondTemplate) {
                        const result = [...state.secondRawTemplates].concat(setTemplatesData(data.results));
                        commit('SET_SECOND_RAW_TEMPLATES', result);
                    } else {
                        const result = [...state.rawTemplates].concat(setTemplatesData(data.results));
                        commit('SET_RAW_TEMPLATES', result);
                    }

                    if (data.count) {
                        commit('SET_TOTAL_TEMPLATES_AMOUNT', data.count);
                    }
                });
        },
        getTemplateQuestions ({ commit }, params = null) {
            return templatesApi.getQuestions(params)
                .then(({ data }) => {
                    commit('SET_RAW_TEMPLATE_QUESTIONS', data.data.map(el => ({
                        id: el.id,
                        ...el.attributes
                    })));
                });
        },
        getQuestionTypes ({ commit, rootState }) {
            return templatesApi.getQuestionTypes({
                params: {
                    'locale': rootState.locale.currentLocale || 'en'
                }
            })
                .then(({ data }) => {
                    commit('SET_TEMPLATE_QUESTION_TYPES', data.data.map(el => ({
                        value: el.id,
                        text: el.attributes.name
                    })));
                });
        },
        assignTemplatesToPoints (context, data) {
            return templatesApi.assignTemplatesToPoints({
                data: data
            });
        },
        unassignTemplatesFromPoints (context, data) {
            return templatesApi.unassignTemplatesFromPoints({
                data: data
            });
        }
    }
};
